import { ONBOARDING_STEPS } from "src/pages/Admin/Home/data";

export const onboardingCompletionPercent = onboarding => ONBOARDING_STEPS.reduce((prev, cur) => {
  if (!onboarding[cur.id]) return prev;

  return prev + cur.percent;
}, 0);
